/**
 * https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript
 */
export function assertUnreachableCode(
  x: never,
  errorMessage = `Unhandled value found: ${x}`
): never {
  throw new Error(errorMessage)
}
